// chartConfig.js
export const chartData1 = [
  { value: 335, name: 'PPT' , itemStyle: { color: '#313ca9' } },
  { value: 310, name: '文档',itemStyle: { color: '#6399ca' } },
  { value: 274, name: '视频' , itemStyle: { color: '#249eff' }},
  { value: 235, name: '作业' }
];

export const chartOption1 = {
  tooltip: {
    trigger: 'item'
  },
  legend: {
    top: '5%',
    left: 'center'
  },
  series: [
    {
      name: '作业完成情况',
      type: 'pie',
      radius: ['50%', '70%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: 'outside',
        formatter: '{b}: {c} ({d}%)'
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 18,
          fontWeight: 'bold'
        }
      },
      labelLine: {
        show: true
      },
      data: chartData1
    }
  ]
};

export const chartData2 = [
  // 数据项2
  { value: 335, name: 'PPT' ,
    itemStyle: {
        color: '#249eff' // 为PPT设置颜色
      }},
    { value: 310, name: '文档' ,itemStyle: {
        color: '#6399ca' // 为文档设置颜色
      }},
    { value: 274, name: '视频' ,itemStyle: {
        color: '#21ccff' // 为视频设置颜色
      }},
    { value: 235, name: '作业' ,itemStyle: {
        color: '#313ca9' // 为作业设置颜色
      }}
];

export const chartOption2 = {
  // 图表2的配置...
  backgroundColor: '#FFFFFF',
  title: {
    text: '作业完成情况',
    left: 'center',
    top: 20,
    textStyle: {
      color: '#000000'
    }
  },
  tooltip: {
    trigger: 'item',
    // 提示框中显示百分比
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  legend: {
    orient: 'vertical', // 图例列表的布局方式，默认为水平布局
    left: 'left',       // 图例组件离容器左侧的距离
    top: 'center',      // 图例组件离容器上侧的距离
    data: ['PPT', '文档', '视频', '作业'] // 图例数据
  },
  series: [
    {
      name: '各类学习资源占比',
      type: 'pie',
      radius: ['35%', '70%'], // 内外半径
      center: ['50%', '50%'],
      data: chartData2,
      roseType: 'radius', // 南丁格尔玫瑰图模式
      label: {
        color: '#000000', // 标签文字颜色
        show: true,       // 显示标签
        position: 'outside', // 标签显示在扇形外侧
        formatter: '{b}\n{d}%' // 标签内容，{b}为名称，{d}为百分比
      },
      labelLine: {
        lineStyle: {
          color: '#000000' // 标签线颜色
        },
        smooth: 0.2,
        length: 10,
        length2: 20
      },
      itemStyle: {
        color: '#20C9FB', // 默认颜色
       
      },
      animationType: 'scale',
      animationEasing: 'elasticOut',
      // animationDelay: function (idx) {
      //   return Math.random() * 200;
      // }
    }
  ]
};